import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import React from "react"
import loadable from "@loadable/component"

const Components = {
  "text-block": loadable(() =>
    import("../../components/global/text-block/text-block")
  ),
  hero: loadable(() => import("../../components/general/hero/hero")),
  "media-banner": loadable(() =>
    import("../../components/global/media-banner/media-banner")
  ),
  "logos-banner": loadable(() =>
    import("../../components/general/logos-banner/logos-banner")
  ),
  "image-table": loadable(() =>
    import("../../components/landing/image-table/image-table")
  ),
  "swiper-carousel-variation-three": loadable(() =>
    import(
      "../../components/general/swiper-carousel-variation-three/swiper-carousel-variation-three"
    )
  ),
  "swiper-carousel-variation-one": loadable(() =>
    import(
      "../../components/general/swiper-carousel-variation-one/swiper-carousel-variation-one"
    )
  ),
  "review-block": loadable(() =>
    import("../../components/general/review-block/review-block")
  ),
  "swiper-carousel-variation-two": loadable(() =>
    import(
      "../../components/global/swiper-carousel-variation-two/swiper-carousel-variation-two"
    )
  ),
  "text-block-image": loadable(() =>
    import("../../components/global/text-block-image/text-block-image")
  ),
  "cms-hero": loadable(() => import("../../components/cms/cms-hero/cms-hero")),
  "cms-hero": loadable(() => import("../../components/cms/cms-hero/cms-hero")),
  "lead-section": loadable(() =>
    import("../../components/general/lead-section/lead-section")
  ),
  "image-gallery-tile": loadable(() =>
    import("../../components/general/image-gallery-tile/image-gallery-tile")
  ),
  "product-carousel-info": loadable(() =>
    import(
      "../../components/product/product-carousel-info/product-carousel-info"
    )
  ),
  codeblock: loadable(() =>
    import("../../components/general/codeblock/codeblock")
  ),
  "product-description": loadable(() =>
    import("../../components/product/product-description/product-description")
  ),
  "instruction-carousel": loadable(() =>
    import(
      "../../components/product/product-instruction-carousel/product-instruction-carousel"
    )
  ),
  "product-feature-image-ingredients": loadable(() =>
    import(
      "../../components/product/product-feature-image-ingredients/product-feature-image-ingredients"
    )
  ),
  "product-award": loadable(() =>
    import("../../components/product/product-award/product-award")
  ),
  review: loadable(() => import("../../components/product/product-review")),
  "items-listing": loadable(() =>
    import("../../components/general/listing/listing")
  ),
  footer: loadable(() => import("../../components/general/footer/footer")),
  "results-usp-variant-two": loadable(() =>
    import("../../components/results-usp-variant-two/results-usp-variant-two")
  ),
  "description-block": loadable(() =>
    import("../../components/general/description-block/description-block")
  ),
  "usp-section": loadable(() =>
    import("../../components/general/usp-section/usp-section")
  ),
}

const DynamicComponent = ({ blok }) => {
  if (typeof Components[blok.component] !== "undefined") {
    const Component = Components[blok.component]
    return (
      <div {...storyblokEditable(blok)}>
        <Component blok={blok} />
      </div>
    )
  }
  return <StoryblokComponent blok={blok} key={blok._uid} />
}

export default DynamicComponent
